import { useSettings } from "~/store/settings";
import config from "~/tailwind.config.js";
import { DateTime as Luxon } from "luxon";

export default defineNuxtRouteMiddleware((to, from) => {
	if (process.server) return;
	const settings = useSettings();
	const stickyVerticalCookie = useCookie("sticky-vertical", {
		expires: Luxon.now().plus({ days: 7 }).toJSDate(),
	});

	if (to && to.fullPath !== from.fullPath && settings.isNativeApp) {
		// Post message for native apps for route changes
		useNuxtApp().$messageHandler({
			message: "Navigate",
			data: { path: to.fullPath, vertical: to.params?.subLobby ? to.params.subLobby : to.fullPath.split("/")[1] },
		});
	}

	try {
		if (!config.theme || !config.theme.colors) {
			throw new Error("No Config Colors");
		}

		const map = {
			// @ts-ignore
			"/lobby/casino": { src: config.theme.colors.casino, default: config.theme.colors.casino["500"], hover: config.theme.colors.casino["600"] },
			// @ts-ignore
			"/lobby/instantgames": {
				// @ts-ignore
				src: config.theme.colors.casino,
				// @ts-ignore
				default: config.theme.colors.casino["500"],
				// @ts-ignore
				hover: config.theme.colors.casino["600"],
			},
			// @ts-ignore
			"/lobby/instant-games": {
				// @ts-ignore
				src: config.theme.colors.casino,
				// @ts-ignore
				default: config.theme.colors.casino["500"],
				// @ts-ignore
				hover: config.theme.colors.casino["600"],
			},
			// @ts-ignore
			"/luckynumbers": { src: config.theme.colors.vegas, default: config.theme.colors.vegas["800"], hover: config.theme.colors.casino["900"] },
			// @ts-ignore
			"/lobby/livecasino": { src: config.theme.colors.casino, default: config.theme.colors.casino["300"], hover: config.theme.colors.casino["400"] },
			// @ts-ignore
			"/lobby/live casino": { src: config.theme.colors.casino, default: config.theme.colors.casino["300"], hover: config.theme.colors.casino["400"] },
			// @ts-ignore
			"/lobby/live-casino": { src: config.theme.colors.casino, default: config.theme.colors.casino["300"], hover: config.theme.colors.casino["400"] },
			// @ts-ignore
			"/lobby/live%20casino": {
				// @ts-ignore
				src: config.theme.colors.casino,
				// @ts-ignore
				default: config.theme.colors.casino["300"],
				// @ts-ignore
				hover: config.theme.colors.casino["400"],
			},
			// @ts-ignore
			"/sport/horse-racing": {
				// @ts-ignore
				src: config.theme.colors.primary,
				// @ts-ignore
				default: config.theme.colors.primary["500"],
				// @ts-ignore
				hover: config.theme.colors.primary["600"],
			},
			// @ts-ignore
			"/sport": { src: config.theme.colors.primary, default: config.theme.colors.primary["500"], hover: config.theme.colors.primary["600"] },
			"/lobby/virtuals": {
				// @ts-ignore
				src: config.theme.colors.virtuals,
				// @ts-ignore
				default: config.theme.colors.virtuals["400"],
				// @ts-ignore
				hover: config.theme.colors.virtuals["500"],
			},
			// @ts-ignore
			"/lobby/betgames": { src: config.theme.colors.vegas, default: config.theme.colors.vegas["800"], hover: config.theme.colors.vegas["900"] },
			// @ts-ignore
			"/esports": { src: config.theme.colors.esports, default: config.theme.colors.esports["600"], hover: config.theme.colors.esports["700"] },
			// @ts-ignore
			"/live": { src: config.theme.colors.primary, default: config.theme.colors.primary["500"], hover: config.theme.colors.primary["600"] },
			// @ts-ignore
			"/betway-jackpot-slots": {
				exclude: true,
				// @ts-ignore
				src: config.theme.colors.casino,
				// @ts-ignore
				default: config.theme.colors.casino["500"],
				// @ts-ignore
				hover: config.theme.colors.casino["600"],
			},
			// @ts-ignore
			"/casino-jackpot-slots": {
				exclude: true,
				// @ts-ignore
				src: config.theme.colors.casino,
				// @ts-ignore
				default: config.theme.colors.casino["500"],
				// @ts-ignore
				hover: config.theme.colors.casino["600"],
			},
			// @ts-ignore
			"/": { src: config.theme.colors.primary, default: config.theme.colors.primary["500"], hover: config.theme.colors.primary["600"] },
		};

		const activeRoute = Object.keys(map).find((key) => to.path.toLowerCase().startsWith(key)) || "/";

		//@ts-ignore
		if (map[activeRoute] && activeRoute !== "/" && !map[activeRoute].exclude) {
			stickyVerticalCookie.value = activeRoute === "/sport" ? "/sport/soccer" : activeRoute;
		}

		// @ts-ignore
		const activeIdentity = to.path.includes("esports") ? map["/esports"] : map[activeRoute] ? map[activeRoute] : map.sport;
		document.documentElement.style.setProperty("--color-identity", activeIdentity.default);
		document.documentElement.style.setProperty("--color-identity-hover", activeIdentity.hover);
		document.documentElement.style.setProperty("--color-identity-50", activeIdentity.src["50"]);
		document.documentElement.style.setProperty("--color-identity-100", activeIdentity.src["100"]);
		document.documentElement.style.setProperty("--color-identity-200", activeIdentity.src["200"]);
		document.documentElement.style.setProperty("--color-identity-300", activeIdentity.src["300"]);
		document.documentElement.style.setProperty("--color-identity-400", activeIdentity.src["400"]);
		document.documentElement.style.setProperty("--color-identity-500", activeIdentity.src["500"]);
		document.documentElement.style.setProperty("--color-identity-600", activeIdentity.src["600"]);
		document.documentElement.style.setProperty("--color-identity-700", activeIdentity.src["700"]);
		document.documentElement.style.setProperty("--color-identity-800", activeIdentity.src["800"]);
		document.documentElement.style.setProperty("--color-identity-900", activeIdentity.src["900"]);
	} catch (error) {
		console.error(error);
		// Fallback to the default primary color
		document.documentElement.style.setProperty("--color-identity", "#00A826");
		document.documentElement.style.setProperty("--color-identity-hover", "#00961A");
		document.documentElement.style.setProperty("--color-identity-50", "#E6F6E7");
		document.documentElement.style.setProperty("--color-identity-100", "#C2E9C3");
		document.documentElement.style.setProperty("--color-identity-200", "#9CDB9D");
		document.documentElement.style.setProperty("--color-identity-300", "#70CE74");
		document.documentElement.style.setProperty("--color-identity-400", "#4AC354");
		document.documentElement.style.setProperty("--color-identity-500", "#16B731");
		document.documentElement.style.setProperty("--color-identity-600", "#00A826");
		document.documentElement.style.setProperty("--color-identity-700", "#00961A");
		document.documentElement.style.setProperty("--color-identity-800", "#00850A");
		document.documentElement.style.setProperty("--color-identity-900", "#006600");
	}
});
